/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown> }} Workout_Swap_Scope_NeverInputs */

const en_us2_workout_swap_scope_never = /** @type {(inputs: Workout_Swap_Scope_NeverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stop recommending ${i?.from}`)
};

const pt_br2_workout_swap_scope_never = /** @type {(inputs: Workout_Swap_Scope_NeverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não recomendar mais ${i?.from}`)
};

const es_419_workout_swap_scope_never = /** @type {(inputs: Workout_Swap_Scope_NeverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No recomendar más ${i?.from}`)
};

const pt_pt2_workout_swap_scope_never = /** @type {(inputs: Workout_Swap_Scope_NeverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não recomendar mais ${i?.from}`)
};

const fr_fr2_workout_swap_scope_never = /** @type {(inputs: Workout_Swap_Scope_NeverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ne plus recommander ${i?.from}`)
};

const de_de2_workout_swap_scope_never = /** @type {(inputs: Workout_Swap_Scope_NeverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} nicht mehr empfehlen`)
};

const it_it2_workout_swap_scope_never = /** @type {(inputs: Workout_Swap_Scope_NeverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Non consigliare più ${i?.from}`)
};

/**
* | output |
* | --- |
* | "Stop recommending {from}" |
*
* @param {Workout_Swap_Scope_NeverInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_scope_never = /** @type {((inputs: Workout_Swap_Scope_NeverInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_Scope_NeverInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_scope_never(inputs)
	if (locale === "es-419") return es_419_workout_swap_scope_never(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_scope_never(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_scope_never(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_scope_never(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_scope_never(inputs)
	return en_us2_workout_swap_scope_never(inputs)
});
export { workout_swap_scope_never as "workout-swap.scope_never" }